import React from 'react';
import './UpdateRequiredDialog.css';

export default function UpdateRequiredDialog({decision, onUpdate}) {
  const maintenance = decision?.reason === 'maintenance';
  return <main className="loop-update-surface">
    <section className="loop-update-dialog" role="dialog" aria-modal="true" aria-labelledby="loop-update-title" aria-describedby="loop-update-description">
      <img className="loop-update-logo" src={`${process.env.PUBLIC_URL || ''}/loop-startup-mark.png`} alt="Loop" />
      <span className="loop-update-eyebrow">{maintenance ? 'Estamos mejorando Loop' : 'Una nueva versión para ti'}</span>
      <h1 id="loop-update-title">{maintenance ? 'Volvemos en un momento' : 'Tu próxima experiencia empieza aquí.'}</h1>
      <p id="loop-update-description">{maintenance ? decision?.message : 'Actualiza Loop para continuar con las últimas mejoras.'}</p>
      <button autoFocus type="button" onClick={onUpdate} disabled={!decision?.storeUrl}>
        Actualizar ahora <span aria-hidden="true">↗</span>
      </button>
      <p className="loop-update-caption">{decision?.storeUrl ? `Abrir ${decision?.platform === 'ios' ? 'App Store' : 'Google Play'}` : 'El enlace de actualización estará disponible pronto. Vuelve a abrir la app en unos minutos.'}</p>
    </section>
  </main>;
}
